// Pure rules for keeping a window open when a text selection ends over its
// backdrop (Stephanie 2026-10-27). The DOM wiring is apps/web/src/lib/
// backdrop-drag.ts; these live here so the offline gate can execute them.

/** Pure: is this element a full-screen overlay (fixed, covers the viewport)? */
export function isFullScreenOverlay(
  style: { position: string },
  rect: { left: number; top: number; width: number; height: number },
  viewport: { width: number; height: number },
): boolean {
  return (
    style.position === "fixed" &&
    rect.left <= 1 &&
    rect.top <= 1 &&
    rect.width >= viewport.width * 0.95 &&
    rect.height >= viewport.height * 0.95
  );
}

/** Pure: swallow this click? Only when the press started inside a child of
 *  the overlay the click landed on (a drag out), never a press on the overlay. */
/** Anything with DOM-style `contains` (a Node) — kept structural so this file
 *  doesn't need the browser's types. */
export interface ContainsLike {
  contains(other: never): boolean;
}

export function isDragOutClick<T extends ContainsLike>(pressTarget: T | null, clickTarget: T, overlay: boolean): boolean {
  return overlay && pressTarget !== null && pressTarget !== clickTarget && clickTarget.contains(pressTarget as never);
}
